import { lazy, Suspense } from 'react';
import { useLocation } from 'react-router';
import type { MultiLang } from '../config';
import CerebellarPlatformCommittee from '../custom/blocks/CerebellarPlatformCommittee';
import CerebrationOfDrItosNewBook from '../custom/blocks/CerebrationOfDrItosNewBook';
import Loading from './lib/Loading';

// A standing bibliography, and by far the largest source file in the app. It
// only ever appears on the top page, so keep it out of the entry chunk.
const NewArticleAlert = lazy(() => import('../custom/blocks/NewArticleAlert'));

import Welcome from '../custom/blocks/Welcome';
import Rankings from '../database/blocks/Rankings';
import RecentContents from '../database/blocks/RecentContents';
import DatabaseTop from '../database/DatabaseTop';
import Functions from '../functions';
import Footer from './Footer';
import MainContent from './MainContent';

interface Props {
    lang: MultiLang;
}

const CenterBlocks = (props: Props) => {
    const { lang } = props;
    return (
        <div className="block">
            <div className="centerCcolumn">
                <div className="block">
                    <div className="blockTitle">Welcome to Cerebellar Platform</div>
                    <div className="blockContent">
                        <Welcome lang={lang} />
                    </div>
                </div>
                <div className="block">
                    <div className="blockTitle">Cerebration of Dr. Ito's New Book</div>
                    <div className="blockContent">
                        <CerebrationOfDrItosNewBook />
                    </div>
                </div>
                <div className="block">
                    <div className="blockTitle">Cerebellar Platfrom Committee</div>
                    <div className="blockContent">
                        <CerebellarPlatformCommittee />
                    </div>
                </div>
                <div className="block">
                    <div className="blockTitle">New article alert</div>
                    <div className="blockContent">
                        <Suspense fallback={<Loading />}>
                            <NewArticleAlert />
                        </Suspense>
                    </div>
                </div>
                <div className="block">
                    <div className="blockTitle">
                        {Functions.mlang('[en]Item Types[/en][ja]アイテムタイプ一覧[/ja]', lang)}
                    </div>
                    <div className="blockContent">
                        <DatabaseTop lang={lang} />
                    </div>
                </div>
            </div>
            <div className="clearfix">
                <div className="centerLcolumn">
                    <div className="block">
                        <div className="blockTitle">{Functions.mlang('[en]Ranking[/en][ja]ランキング[/ja]', lang)}</div>
                        <div className="blockContent">
                            <Rankings lang={lang} />
                        </div>
                    </div>
                </div>
                <div className="centerRcolumn">
                    <div className="block">
                        <div className="blockTitle">
                            {Functions.mlang('[en]Recent Contents[/en][ja]新着コンテンツ[/ja]', lang)}
                        </div>
                        <div className="blockContent">
                            <RecentContents lang={lang} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const CenterColumn = (props: Props) => {
    const { lang } = props;
    const { pathname } = useLocation();

    return (
        <div className="centercolumn">
            {pathname === '/' && <CenterBlocks lang={lang} />}
            <div className="block">
                <MainContent lang={lang} />
            </div>
            <div className="block">
                <div id="page_top">
                    <a href="#header">
                        <span className="hidden">Go Page Top</span>
                    </a>
                </div>
                <Footer lang={lang} />
            </div>
        </div>
    );
};

export default CenterColumn;
